/* /assets/theme-dev.js
 * Custom JS for COMING HOME theme.
 * Loaded after theme.js via layout/theme.liquid.
 *
 * Must be loaded as a real <script src> (not inline-injected via Section
 * Rendering API), so the IIFE bootstraps even on pages that DO NOT render
 * a launch snippet in their initial server-rendered DOM — Quick View and
 * other AJAX-loaded surfaces inject HTML via innerHTML, which silently
 * skips <script> execution per the HTML spec.
 */
(function () {
  if (window.__launchUIInit) return;
  window.__launchUIInit = true;

  // Convert [data-launch-readable-date] <time> elements to the customer's
  // local timezone. Shopify stores date_time metafields as UTC and the
  // Liquid | date: filter does not auto-convert to shop timezone; the
  // server fallback may show a shifted time. Browsers parse the ISO
  // datetime attribute correctly and toLocaleString renders in the
  // customer's own zone.
  //
  // :not([data-launch-converted]) makes this safe to call every tick —
  // an element only gets its textContent rewritten the first time it's
  // seen. Needed because some surfaces (Quick View modal, etc.) inject
  // their HTML via the Section Rendering API *after* DOMContentLoaded
  // and do NOT fire shopify:section:load.
  var convertReadableDate = function (root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-launch-readable-date]:not([data-launch-converted])').forEach(function (el) {
      var iso = el.getAttribute('datetime');
      if (!iso) return;
      var d = new Date(iso);
      if (isNaN(d.getTime())) return;
      try {
        el.textContent = d.toLocaleString(undefined, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });
        el.setAttribute('data-launch-converted', 'true');
      } catch (e) { /* keep server-rendered fallback */ }
    });
  };

  // Expire failsafe — hides launch UI before the native <countdown-timer>
  // web component renders garbage (its update() in theme.js does not
  // return after onComplete(), producing "0-6"d / NaN h/m/s on expired
  // countdowns).
  //
  // Two modes via [data-launch-wrapper] (sections/launch-collection-banner.liquid;
  // DS: the PDP "reload-prompt" mode was removed 2026-11-02 with the
  // custom.launch_date product countdown):
  //   - default (no value): hide the countdown block (auto-hide banner).
  //   - "soft-swap": hide wrapper + reveal companion element pointed to by
  //     data-launch-swap-to (CSS selector). Swaps State A -> State B
  //     in-session without page reload. Server pre-renders both states;
  //     State B starts with inline display:none.
  var expireWrapper = function (wrapper) {
    if (wrapper.dataset.launchExpired === 'true') return;
    wrapper.dataset.launchExpired = 'true';
    var mode = wrapper.getAttribute('data-launch-wrapper') || '';
    if (mode === 'soft-swap') {
      var targetSelector = wrapper.getAttribute('data-launch-swap-to');
      if (targetSelector) {
        var target = document.querySelector(targetSelector);
        if (target) target.style.display = '';
      }
      wrapper.style.display = 'none';
      return;
    }
    wrapper.style.display = 'none';
  };

  var checkExpired = function (root) {
    var scope = root && root.querySelectorAll ? root : document;
    var now = Date.now();
    scope.querySelectorAll('[data-launch-wrapper]').forEach(function (wrapper) {
      var timeEl = wrapper.querySelector('time[datetime]');
      if (!timeEl) return;
      var iso = timeEl.getAttribute('datetime');
      if (!iso) return;
      var d = new Date(iso);
      if (isNaN(d.getTime())) return;
      if (d.getTime() <= now) expireWrapper(wrapper);
    });
  };

  var run = function (root) {
    convertReadableDate(root);
    checkExpired(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  // Catch in-session expirations (cached pages, customers watching a
  // countdown tick to zero) AND late-injected DOM (Quick View modal
  // loaded via the Section Rendering API after DOMContentLoaded, which
  // does NOT fire shopify:section:load). 1 Hz matches the native
  // countdown ticker cadence — extra work is microseconds because both
  // helpers use :not([data-launch-*]) selectors to skip already-handled
  // elements.
  setInterval(function () {
    convertReadableDate(document);
    checkExpired(document);
  }, 1000);

  // Theme Editor section reloads
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

// Greeting card bridge — inject line item property to upsell card form on ATC.
//
// Renders as a text input in .product__block__upsell area (via
// sections/product.liquid upsell block schema.greeting_* fields). Value bridges
// to the SIBLING product-clip form's hidden properties[<key>] on submit/click,
// so the greeting message attaches to the gift (upsell) product's line item
// natively — matches how Globo Product Options attaches GREETING CARD on the
// gift box's own PDP. Same line-item-property surface flows through cart,
// checkout, order admin, and order email without extra work.
//
// Empty value = no property injected (Shopify convention, avoid empty prop
// noise in cart). Idempotent — form.dataset.greetingBound + capture-phase
// listeners handle Alpine.js productAddButtonForm() takeover safely.
(function () {
  if (window.__greetingCardInit) return;
  window.__greetingCardInit = true;

  var updateCounter = function (input) {
    var block = input.closest('[data-greeting-card-block]');
    if (!block) return;
    var counter = block.querySelector('[data-greeting-counter]');
    if (!counter) return;
    var max = input.maxLength > 0 ? input.maxLength : 200;
    counter.textContent = input.value.length + '/' + max + ' characters';
  };

  var injectProperty = function (input) {
    var upsell = input.closest('.product__block__upsell');
    if (!upsell) return;
    var form = upsell.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var key = input.getAttribute('data-greeting-key') || 'GREETING CARD';
    var value = (input.value || '').trim();
    // Remove any previously-injected input for this key
    var existing = form.querySelector('input[data-greeting-injected="true"]');
    if (existing) existing.remove();
    if (value === '') return; // Skip empty per Shopify convention
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'properties[' + key + ']';
    hidden.value = value;
    hidden.setAttribute('data-greeting-injected', 'true');
    form.appendChild(hidden);
  };

  var bindForm = function (input) {
    var upsell = input.closest('.product__block__upsell');
    if (!upsell) return;
    var form = upsell.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    if (form.dataset.greetingBound === 'true') return;
    form.dataset.greetingBound = 'true';
    // Capture-phase so we inject BEFORE Alpine.js productAddButtonForm() intercepts.
    form.addEventListener('submit', function () { injectProperty(input); }, true);
    var atc = form.querySelector('[data-add-to-cart]');
    if (atc) {
      atc.addEventListener('click', function () { injectProperty(input); }, true);
    }
  };

  // Move greeting card block INTO the product-clip card, positioned between
  // title/price link and the ATC form container — matches Globo greeting card
  // layout on the gift box's own PDP (label + input + counter directly above
  // ATC button). Liquid renders the block as a sibling BEFORE product-clip
  // because product-clip is a shared snippet we don't want to invasively
  // parameterize; JS relocates post-render.
  //
  // Idempotent via ancestor check — if the block is already inside
  // .product-clip__content, no-op.
  var repositionIntoCard = function (block) {
    if (!block) return;
    var content = block.closest('.product__block__upsell')?.querySelector('.product-clip__content');
    if (!content) return;
    if (block.parentElement === content) return; // already positioned
    var form = content.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    // Walk up from form until we find the direct child of .product-clip__content
    var target = form;
    while (target.parentElement && target.parentElement !== content) {
      target = target.parentElement;
    }
    content.insertBefore(block, target);
  };

  var bindInput = function (input) {
    var block = input.closest('[data-greeting-card-block]');
    if (block) repositionIntoCard(block);
    if (input.dataset.greetingBound === 'true') return;
    input.dataset.greetingBound = 'true';
    input.addEventListener('input', function () { updateCounter(input); });
    updateCounter(input);
    bindForm(input);
  };

  var initGreeting = function (root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-greeting-source]').forEach(bindInput);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGreeting(document); });
  } else {
    initGreeting(document);
  }

  // Late-injected DOM (Quick View modal via Section Rendering API, etc.)
  setInterval(function () { initGreeting(document); }, 1000);

  document.addEventListener('shopify:section:load', function (e) { initGreeting(e.target); });
})();

// DS: start — launch lookbook card images (sections/launch-lookbook-grid.liquid).
// Manual image switching instead of the native hover slideshow: dots under the
// image, arrows on the image and a hover preview of image 2 (mouse devices),
// and a horizontal swipe on touch screens. Images switch through the native
// <product-grid-item-image> attributes, so images still in a <template> load on
// first selection. Cards below the first row also keep their first image in a
// <template> until it nears the viewport. Delegated, so Theme Editor reloads work.
(function () {
  if (window.__lookbookDotsInit) return;
  window.__lookbookDotsInit = true;

  var CARD = '.launch-lookbook-grid product-grid-item';
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function show(card, index) {
    var images = card.querySelectorAll('[data-grid-image]');
    if (images.length < 2) return;
    index = (index + images.length) % images.length;
    var target = images[index];
    target.setAttribute('loading', 'eager');
    images.forEach(function (image) {
      if (image !== target) image.removeAttribute('data-grid-current-image');
    });
    target.setAttribute('data-grid-current-image', 'true');
    card.querySelectorAll('[data-lookbook-dot]').forEach(function (dot, i) {
      dot.classList.toggle('is-selected', i === index);
      if (i === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    card.dataset.lookbookImage = index;
  }

  function current(card) {
    return parseInt(card.dataset.lookbookImage, 10) || 0;
  }

  // A choice made with dots, arrows or swipe is kept when the mouse leaves
  function choose(card, index) {
    card.dataset.lookbookChosen = 'true';
    show(card, index);
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-lookbook-dot]');
    var arrow = !dot && e.target.closest('[data-lookbook-arrow]');
    var card = (dot || arrow) && (dot || arrow).closest(CARD);
    if (!card) return;
    if (arrow) {
      e.preventDefault();
      choose(card, current(card) + parseInt(arrow.getAttribute('data-lookbook-arrow'), 10));
    } else {
      choose(card, parseInt(dot.getAttribute('data-lookbook-dot'), 10));
    }
  });

  // Hover preview (mouse devices): entering a card on image 1 shows image 2;
  // leaving goes back to image 1 unless the visitor picked an image meanwhile.
  // mouseenter/mouseleave do not bubble, so they are caught in the capture phase.
  document.addEventListener('mouseenter', function (e) {
    if (!canHover.matches || !(e.target instanceof Element) || !e.target.matches(CARD)) return;
    var card = e.target;
    card.dataset.lookbookChosen = '';
    if (current(card) === 0 && card.querySelectorAll('[data-grid-image]').length > 1) {
      card.dataset.lookbookPreview = 'true';
      show(card, 1);
    }
  }, true);

  document.addEventListener('mouseleave', function (e) {
    if (!(e.target instanceof Element)) return;
    // The native card's only mouseleave job is rewinding to the first image;
    // stop it in the capture phase so the image follows the rules above
    if (e.target.matches(CARD + ' product-grid-item-variant')) {
      e.stopPropagation();
      return;
    }
    if (!e.target.matches(CARD)) return;
    var card = e.target;
    if (card.dataset.lookbookPreview === 'true' && card.dataset.lookbookChosen !== 'true') show(card, 0);
    card.dataset.lookbookPreview = '';
  }, true);

  var swipe = null;
  document.addEventListener('touchstart', function (e) {
    var images = e.touches.length === 1 && e.target.closest('.launch-lookbook-grid [data-grid-images]');
    swipe = images ? { card: images.closest(CARD), x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!swipe || !swipe.card) return;
    var touch = e.changedTouches[0];
    var dx = touch.clientX - swipe.x;
    var dy = touch.clientY - swipe.y;
    var card = swipe.card;
    swipe = null;
    // Horizontal swipes only, so vertical page scrolling is untouched
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    choose(card, current(card) + (dx < 0 ? 1 : -1));
  }, { passive: true });

  // Deferred first images: loading="eager" makes the native component swap the
  // <template> for the real <img> (assets/custom.js cannot force-load them first)
  var lazyObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      lazyObserver.unobserve(entry.target);
      entry.target.setAttribute('loading', 'eager');
    });
  }, { rootMargin: '600px 0px' }) : null;

  function watchDeferred(root) {
    (root || document).querySelectorAll('.launch-lookbook-grid [data-lookbook-lazy]').forEach(function (image) {
      if (image.dataset.lookbookWatched) return;
      image.dataset.lookbookWatched = 'true';
      if (lazyObserver) lazyObserver.observe(image);
      else image.setAttribute('loading', 'eager');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watchDeferred(document); });
  } else {
    watchDeferred(document);
  }
  document.addEventListener('shopify:section:load', function (e) { watchDeferred(e.target); });
})();
// DS: end
